<template>
  <div>
    <UmkmBermitraMain></UmkmBermitraMain>
    <AppFooter></AppFooter>
  </div>
</template>

<script>
import UmkmBermitraMain from "@/components/public-umkm-bermitra/UmkmBermitraMain.vue";
import AppFooter from "@/components/AppFooter.vue";

export default {
  name: "UmkmBermitraView",
  components: {
    AppFooter,
    UmkmBermitraMain
  }
}
</script>

<style scoped>

</style>